/** Strings owned by `src/manage/overview/` — "Beheer › Overzicht"
 * (PLAN-FASE3.md WP-05): the platform-staff-only KPI overview. No NPS or
 * AI-summary card — out of scope, see AdminOverviewPage.tsx. */
export const manageOverview = {
  page: {
    title: 'Visão geral',
    lead: 'Indicadores-chave da plataforma: receita, empresas e utilizadores ativos, e retenção.',
    activeCompanies: 'Empresas ativas',
    activeUsers: 'Utilizadores ativos',
    revenueThisMonth: 'Receita este mês',
    retention: 'Retenção (mês a mês)',
    retentionUnavailable: 'Ainda sem dados',
    retentionDetail: '{{retained}} de {{total}} empresas retidas',
  },
} as const;
